import {
    RESET_THE_STORE_TO_INITIAL_STATE,
    RETRIEVE_MACTIONS,
  } from "../actions/types";
  
  const initialState = {    
    mactions: [],
  };
  
  function mactionsReducer(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {

      case RESET_THE_STORE_TO_INITIAL_STATE:
        return {
          ...initialState
        }
  
      case RETRIEVE_MACTIONS:
        if(!payload) return state; 
        return {
                ...state,
                mactions: payload,
        }

      default:
        return state;
    }
  };
  
  export default mactionsReducer;